angular.module('history')
.controller('HistoryController', ['$scope', '$state', 'Auth', 'Referral', 'Logger', 'Practice', 'referralColorClasses', '$uibModal', 'ModalHandler', 'EmailSuppressionWarning', 'TrialExpiryWarning',
    function ($scope, $state, Auth, Referral, Logger, Practice, referralColorClasses, $uibModal, ModalHandler, EmailSuppressionWarning, TrialExpiryWarning) {
        var params = $state.params,
            suppressParamsHandling = false;
        $scope.limitTo = 20;
        $scope.referrals = [];
        // DCL-539: current-month incoming-allowance usage ({used, limit}) for the
        // quiet meter in the header. Absent (null) for practices with no metered
        // allowance — Premium or General Dentistry — so no meter renders.
        $scope.allowance = null;
        // DCL-592: this month's counts for the link to the Plan & usage page,
        // shown to every practice.
        $scope.insightsLine = null;

        // DCL-172: sample rows shown while the practice has no referrals yet, so
        // a new user immediately sees what the list will hold. Purely client-side
        // — they vanish once any real (or gated) referral exists or a filter is
        // active. Clicking one opens a watermarked screenshot of the referral
        // page, so the row data must match what its screenshot shows (including
        // the dates baked into the image).
        $scope.showDemoPlaceholders = false;
        $scope.demoReferrals = [
            {
                updated_at: new Date(2026, 2, 31),
                status: 'new',
                patient: { first_name: 'James', last_name: 'Wilson' },
                orig_provider: { first_name: 'Sarah', last_name: 'Mitchell' },
                orig_practice: { name: 'Bright Smiles Family Dentistry' },
                dest_provider: { first_name: 'Robert', last_name: 'Chen' },
                dest_practice: { name: 'Summit Endodontics' },
                image: 'img/demo/sample-referral-endo.png'
            },
            {
                updated_at: new Date(2026, 2, 31),
                status: 'scheduled',
                patient: { first_name: 'Amanda', last_name: 'Foster' },
                orig_provider: { first_name: 'Sarah', last_name: 'Mitchell' },
                orig_practice: { name: 'Bright Smiles Family Dentistry' },
                dest_provider: { first_name: 'Rachel', last_name: 'Greenfield' },
                dest_practice: { name: 'Precision Periodontics & Implants' },
                image: 'img/demo/sample-referral-implant.png'
            }
        ];

        $scope.referralColorClasses = referralColorClasses;

        // DCL-462: warn once per session if this user's address is suppressed
        // by the email provider while their preference expects notifications.
        // Deliberately outside the $state.params watcher below, which re-fires
        // on every filter change.
        EmailSuppressionWarning.checkAndNotify();

        // DCL-507: warn once per session during the final 7 days of a
        // complimentary Premium trial. Same placement reasoning as above.
        TrialExpiryWarning.checkAndNotify();

        $scope.$watchCollection(function () {
            return $state.params;
        }, function () {
            if (!suppressParamsHandling) {
                fillQueryFromParams();
                queryReferrals();
            }
            suppressParamsHandling = false;
        });

        function fillQueryFromParams() {
            $scope.query = params.query ? params.query : null;
            $scope.statusFilter = params.status ? params.status : null;
            $scope.start_date = params.start ? new Date(params.start) : moment(0);
            $scope.end_date = params.end ? new Date(params.end) : moment().endOf('day');
        };

        function queryReferrals() {
            var auth = Auth.getOrRedirect();
            if (!auth) {
                return; // redirected to sign in
            }
            $scope.busy = true;
            $scope.showDemoPlaceholders = false;
            Referral.findByPractice({
                id: auth.practice_id,
                start_date: $scope.start_date.toISOString(), end_date: $scope.end_date.toISOString(),
                term: $scope.query, status: $scope.statusFilter, limit: $scope.limitTo
            }, function (data) {
                $scope.referrals = data.referrals;
                $scope.referrals_total_count = data.referrals_total_count;
                $scope.allowance = data.incoming_allowance || null;
                $scope.insightsLine = data.insights_line || null;
                $scope.busy = false;
                updateDemoPlaceholders();
            }, function (error) {
                $scope.busy = false;
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load referrals', error);
                }
            });
        };

        // DCL-172: only a truly empty, unfiltered history gets the sample rows —
        // an empty *filtered* result must stay empty. The default (untouched)
        // date range starts at epoch, so a nonzero start date means the user
        // picked a range.
        function updateDemoPlaceholders() {
            var filtersActive = $scope.query || $scope.statusFilter || $scope.start_date.valueOf() !== 0;
            $scope.showDemoPlaceholders = !filtersActive && !$scope.referrals.length;
        };

        $scope.openDemoReferral = function (demo) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/demo_referral_modal.html',
                controller: 'DemoReferralModalController',
                size: 'lg',
                resolve: {
                    demoReferral: function () { return demo; }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (action) {
                if (action === 'create') {
                    $scope.newRefferal();
                }
            }, angular.noop); // dismissing the demo is not an error
        };

        $scope.findReferralsByDateRange = function (start, end) {
            suppressParamsHandling = true;
            $state.go('.', { start: start.toISOString(), end: end.toISOString() }, { notify: false });
            $scope.start_date = start;
            $scope.end_date = end;
            queryReferrals();
        };

        $scope.findReferralsByTerm = function () {
            suppressParamsHandling = true;
            $state.go('.', { query: $scope.query }, { notify: false });
            queryReferrals();
        };

        $scope.findReferralsByStatus = function () {
            suppressParamsHandling = true;
            $state.go('.', { status: $scope.statusFilter }, { notify: false });
            queryReferrals();
        };

        $scope.addMoreItems = function () {
            var auth = Auth.getOrRedirect();
            if (!auth) {
                return; // redirected to sign in
            }
            $scope.busy = true;
            var offset = $scope.referrals.length;
            Referral.findByPractice({ id: auth.practice_id, start_date: $scope.start_date.toISOString(), end_date: $scope.end_date.toISOString(), term: $scope.query, status: $scope.statusFilter, limit: $scope.limitTo, offset: offset },
                function (data) {
                    for (var i = 0; i < data.referrals.length; i++) {
                        $scope.referrals.push(data.referrals[i]);
                    }
                    $scope.referrals_total_count = data.referrals_total_count;
                    $scope.busy = false;
                }, function (error) {
                    $scope.busy = false;
                    // Silently handle authentication errors as authInterceptor will handle the redirect
                    if (error.status !== 401 && error.status !== 403) {
                        Logger.log('Failed to load more referrals', error);
                    }
                });
        };

        function pluralize(count, noun) {
            return count + ' ' + noun + (count === 1 ? '' : 's');
        }

        // DCL-592: e.g. "7 referrals from 4 practices this month". Empty for a
        // month with no referrals, which leaves the link alone on the line. A
        // general dentist's version never mentions a quota.
        $scope.insightsLineText = function () {
            var line = $scope.insightsLine;
            if (!line || !line.referral_count) { return ''; }

            var isGeneralDentist = line.audience === 'general_dentistry';
            var text = pluralize(line.referral_count, 'referral');
            if (isGeneralDentist) { text += ' sent'; }
            if (line.practice_count) {
                text += isGeneralDentist
                    ? ' to ' + pluralize(line.practice_count, 'specialist')
                    : ' from ' + (line.practice_count === 1 ? '1 practice' : line.practice_count + ' practices');
            }
            return text + ' this month';
        };

        // The meter never draws past its track even when more referrals arrived
        // than the quota covers.
        $scope.allowanceMeterPercent = function () {
            if (!$scope.allowance || !$scope.allowance.limit) { return 0; }
            return Math.min(100, Math.round($scope.allowance.used * 100 / $scope.allowance.limit));
        };

        $scope.newRefferal = function () {
            var auth = Auth.getOrRedirect();
            if (!auth) {
                return; // redirected to sign in
            }
            Practice.checkContainsDoctor({ practiceId: auth.practice_id }, {}, function (success) {
                if (success.result) {
                    $state.go('createReferral');
                } else {
                    $state.go('error_page', { error_key: 'practice.doctor.not.found' });
                }
            });
        };
    }]);
